module.exports = __webpack_public_path__ + "static/media/save_the_waves.fb619165.png";